import React, { useState, useEffect, useMemo } from 'react';
import { useUnifyAdminStore } from '../../AdminStore';
import * as StyledComponents from '../StyledComponents';
import get from 'lodash/get';
import {
    BUTTON_VARIANTS,
    Button as RadialButton,
    INPUT_SIZES
} from 'cdk-radial';
import { AgGridReact } from "ag-grid-react";
import { ICellRendererParams, GridApi, ColumnApi } from 'ag-grid-community';

interface TabItem {
    id: string;
    panelId: string;
    renderPanel: any;
    renderTab: any;
}

export const OutageBulkUploadedDataView = (): JSX.Element => {

    const sideSheetData = useUnifyAdminStore(
        (state) => state.productOutageSideSheetData);

    const updateProductOutageSideSheetData = useUnifyAdminStore(
        (state) => state.updateProductOutageSideSheetData
    );

    const uploadedEnterprises = get(sideSheetData, 'uploadedEnterprises');
    const uploadedStores = get(sideSheetData, 'uploadedStores');
    const uploadedCNumbers = get(sideSheetData, 'uploadedCNumbers');
    const gridEnterpriseData = get(sideSheetData, 'gridEnterpriseData');
    const gridStoresData = get(sideSheetData, 'gridStoresData');
    const gridCNumberData = get(sideSheetData, 'gridCNumberData');
    const gridEnterpriseSerachValue = get(sideSheetData, 'gridEnterpriseSerachValue', '');
    const gridStoresSearchValue = get(sideSheetData, 'gridStoresSearchValue', '');
    const gridCNumberSerachValue = get(sideSheetData, 'gridCNumberSerachValue', '');

    const [selectedEnterprises, setSelectedEnterprises] = useState(gridEnterpriseData?.filter((item) => item.isSelected));
    const [selectedStores, setSelectedStores] = useState(gridStoresData?.filter((item) => item.isSelected));
    const [selectedCNumbers, setSelectedCNumbers] = useState(gridCNumberData?.filter((item) => item.isSelected));

    useEffect(() => {
        if (uploadedEnterprises !== undefined) {
            const enterpriseArray = uploadedEnterprises.split(',').map(name => name.trim()).filter(name => name !== "");

            const formattedArray = enterpriseArray.map((name, index) => ({
                isSelected: true,
                name: name
            }));
            updateProductOutageSideSheetData({
                fieldName: 'gridEnterpriseData',
                value: formattedArray,
            });
            setSelectedEnterprises(formattedArray?.filter((item) => item.isSelected));
        }
    }, [uploadedEnterprises, updateProductOutageSideSheetData]);

    useEffect(() => {
        if (uploadedStores !== undefined) {
            const storesArray = uploadedStores.split(',').map(name => name.trim()).filter(name => name !== "");

            const formattedArray = storesArray.map((name, index) => ({
                isSelected: true,
                name: name
            }));
            updateProductOutageSideSheetData({
                fieldName: 'gridStoresData',
                value: formattedArray,
            });

            setSelectedStores(formattedArray?.filter((item) => item.isSelected));
        }
    }, [uploadedStores, updateProductOutageSideSheetData]);

    useEffect(() => {
        if (uploadedCNumbers !== undefined) {
            const cnumberArray = uploadedCNumbers.split(',').map(name => name.trim()).filter(name => name !== "");

            const formattedArray = cnumberArray.map((name, index) => ({
                isSelected: true,
                name: name
            }));
            updateProductOutageSideSheetData({
                fieldName: 'gridCNumberData',
                value: formattedArray,
            });

            setSelectedCNumbers(formattedArray?.filter((item) => item.isSelected));
        }
    }, [uploadedCNumbers, updateProductOutageSideSheetData]);

    const onCellClickedEnterprises = (event: any) => {
        setSelectedEnterprises(gridEnterpriseData?.filter((item) => item.isSelected));
        updateProductOutageSideSheetData({
            fieldName: 'targetEnterprises',
            value: gridEnterpriseData
                ?.filter(item => item.isSelected)
                .map(item => item.name)
                .join(","),
        });
    }

    const onCellClickedStores = (event: any) => {
        setSelectedStores(gridStoresData?.filter((item) => item.isSelected));
        updateProductOutageSideSheetData({
            fieldName: 'targetStores',
            value: gridStoresData
                ?.filter(item => item.isSelected)
                .map(item => item.name)
                .join(","),
        });
    }

    const onCellClickedCNumbers = (event: any) => {
        setSelectedCNumbers(gridCNumberData?.filter((item) => item.isSelected));
        updateProductOutageSideSheetData({
            fieldName: 'targetCNumbers',
            value: gridCNumberData
                ?.filter(item => item.isSelected)
                .map(item => item.name)
                .join(","),
        });
    }

    const onClose = () => {
        updateProductOutageSideSheetData({
            fieldName: 'showFileData',
            value: false,
        });
        updateProductOutageSideSheetData({
            fieldName: 'uploadedEnterprises',
            value: gridEnterpriseData
                ?.filter(item => item.isSelected)
                .map(item => item.name)
                .join(","),
        });
        updateProductOutageSideSheetData({
            fieldName: 'uploadedStores',
            value: gridStoresData
                ?.filter(item => item.isSelected)
                .map(item => item.name)
                .join(","),
        });
        updateProductOutageSideSheetData({
            fieldName: 'uploadedCNumbers',
            value: gridCNumberData
                ?.filter(item => item.isSelected)
                .map(item => item.name)
                .join(","),
        });
    };

    const onCNumberDeleteData = () => {
        updateProductOutageSideSheetData({
            fieldName: 'uploadedCNumbers',
            value: '',
        });
        updateProductOutageSideSheetData({
            fieldName: 'gridCNumberData',
            value: [],
        });
        setSelectedCNumbers([]);
        updateProductOutageSideSheetData({
            fieldName: 'targetCNumbers',
            value: '',
        });
    };

    const onEnterpriseDeleteData = () => {
        updateProductOutageSideSheetData({
            fieldName: 'uploadedEnterprises',
            value: '',
        });
        updateProductOutageSideSheetData({
            fieldName: 'gridEnterpriseData',
            value: [],
        });
        setSelectedEnterprises([]);
        updateProductOutageSideSheetData({
            fieldName: 'targetEnterprises',
            value: '',
        });
    };

    const onStoresDeleteData = () => {
        updateProductOutageSideSheetData({
            fieldName: 'uploadedStores',
            value: '',
        });
        updateProductOutageSideSheetData({
            fieldName: 'gridStoresData',
            value: [],
        });
        setSelectedStores([]);
        updateProductOutageSideSheetData({
            fieldName: 'targetStores',
            value: '',
        });
    };

    const [activeItemIndex, setActiveItemIndex] = React.useState(0);

    const columnDefEnterprises = useMemo(() => [
        {
            width: 60,
            headerName: "",
            field: "isSelected",
            cellRenderer: (params: ICellRendererParams) => (
                <input
                    type="checkbox"
                    checked={params.value}
                    onChange={() => {
                        params.node.setDataValue('isSelected', !params.value)
                    }}
                />
            )
        },
        {
            headerName: "Enterprise ID",
            field: "name",
            flex: 1
        }
    ], []);

    const columnDefCNumbers = useMemo(() => [
        {
            width: 60,
            headerName: "",
            field: "isSelected",
            cellRenderer: (params: ICellRendererParams) => (
                <input
                    type="checkbox"
                    checked={params.value}
                    onChange={() => {
                        setSelectedCNumbers(gridCNumberData?.filter((item) => item.isSelected));
                        params.node.setDataValue('isSelected', !params.value)
                    }}
                />
            )
        },
        {
            headerName: "CNumber",
            field: "name",
            flex: 1
        }
    ], [gridCNumberData]);

    const columnDefStores = useMemo(() => [
        {
            width: 60,
            headerName: "",
            field: "isSelected",
            cellRenderer: (params: ICellRendererParams) => (
                <input
                    type="checkbox"
                    checked={params.value}
                    onChange={() => {
                        setSelectedStores(gridStoresData?.filter((item) => item.isSelected));
                        params.node.setDataValue('isSelected', !params.value)
                    }}
                />
            )
        },
        {
            headerName: "Stores",
            field: "name",
            flex: 1
        }
    ], [gridStoresData]);

    const handleEnterpriseChangeSearchValue = (e: string) => {
        updateProductOutageSideSheetData({
            fieldName: 'gridEnterpriseSerachValue',
            value: e,
        });
    }

    const handleCNumberChangeSearchValue = (e: string) => {
        updateProductOutageSideSheetData({
            fieldName: 'gridCNumberSerachValue',
            value: e,
        });
    }

    const handleStoresChangeSearchValue = (e: string) => {
        updateProductOutageSideSheetData({
            fieldName: 'gridStoresSearchValue',
            value: e,
        });
    }
  
    let tabs: TabItem[] = [];

    tabs.push({
        id: 'tab-1',
        panelId: 'panel-1',
        renderPanel: (props: any) => (
            <StyledComponents.StyledTabPanel {...props}>
                <div style={{ width: '400px' }}>
                    <div style={{ display: 'inline-flex', width: '100%' }}>
                        <StyledComponents.StyledSearchBoxNotification
                            dataTestId="enterprise-search-input"
                            className="customize-search-input"
                            clearButtonLabel="clearButtonLabel"
                            id="enterprise-search-input"
                            isAlwaysExpanded
                            name="enterprise-search-input"
                            onChange={(e: string) => handleEnterpriseChangeSearchValue(e)}
                            placeholder="Search"
                            size={INPUT_SIZES.STANDARD}
                            value={gridEnterpriseSerachValue}
                        />
                        <RadialButton text="Delete All" style={{ color: "#006CFA", marginLeft: '30%', fontSize: '12px', marginTop: '20px'  }} onClick={onEnterpriseDeleteData} variant={BUTTON_VARIANTS.TEXT} >
                        </RadialButton>
                    </div>
                    <StyledComponents.StyledTableContainer>
                        <StyledComponents.StyledTableWrapper className="ag-theme-alpine">
                            <AgGridReact
                                rowData={gridEnterpriseData}
                                columnDefs={columnDefEnterprises}
                                rowSelection="multiple"
                                suppressRowClickSelection={false}
                                pagination={true}
                                paginationPageSize={15}
                                onCellClicked={onCellClickedEnterprises}
                                onGridReady={onGridEnterprisesReady}
                            />
                        </StyledComponents.StyledTableWrapper>
                    </StyledComponents.StyledTableContainer>
                    <div style={{ fontSize: '12px', marginLeft: '10px' }}>{selectedEnterprises?.length} Selected out of {gridEnterpriseData?.length} Enterprises</div>
                </div>
            </StyledComponents.StyledTabPanel>
        ),
        renderTab: (props: any) => (
            <StyledComponents.StyledTab
                label="Enterprises"
                {...props}
            />
        ),
    });

    tabs.push({
        id: 'tab-2',
        panelId: 'panel-2',
        renderPanel: (props: any) => (
            <StyledComponents.StyledTabPanel {...props}>
                <div style={{ width: '400px' }}>
                    <div style={{ display: 'inline-flex', width: '100%' }}>
                        <StyledComponents.StyledSearchBoxNotification
                            dataTestId="cnumber-search-input"
                            className="customize-search-input"
                            clearButtonLabel="clearButtonLabel"
                            id="cnumber-search-input"
                            isAlwaysExpanded
                            name="cnumber-search-input"
                            onChange={(e: string) => handleCNumberChangeSearchValue(e)}
                            placeholder="Search"
                            size={INPUT_SIZES.STANDARD}
                            value={gridCNumberSerachValue}
                        />
                        <RadialButton text="Delete All" style={{ color: "#006CFA", marginLeft: '30%', fontSize: '12px', marginTop: '20px' }} onClick={onCNumberDeleteData} variant={BUTTON_VARIANTS.TEXT} >
                        </RadialButton>
                    </div>
                    <StyledComponents.StyledTableContainerSidesheet>
                        <StyledComponents.StyledTableWrapper className="ag-theme-alpine">
                            <AgGridReact
                                rowData={gridCNumberData}
                                columnDefs={columnDefCNumbers}
                                rowSelection="multiple"
                                suppressRowClickSelection={false}
                                pagination={true}
                                paginationPageSize={15}
                                onCellClicked={onCellClickedCNumbers}
                                onGridReady={onGridCNumbersReady}
                            />
                        </StyledComponents.StyledTableWrapper>
                    </StyledComponents.StyledTableContainerSidesheet>
                    <div style={{ fontSize: '12px', marginLeft: '10px' }}>{selectedCNumbers?.length} Selected out of {gridCNumberData?.length} CNumbers</div>

                </div>
            </StyledComponents.StyledTabPanel>
        ),
        renderTab: (props: any) => (
            <StyledComponents.StyledTab
                label="CNumbers"
                {...props}
            />
        ),
    });

    tabs.push({
        id: 'tab-2',
        panelId: 'panel-2',
        renderPanel: (props: any) => (
            <StyledComponents.StyledTabPanel {...props}>
                <div style={{ width: '400px'}}>
                    <div style={{ display: 'inline-flex', width: '100%' }}>
                        <StyledComponents.StyledSearchBoxNotification
                            dataTestId="store-search-input"
                            className="customize-search-input"
                            clearButtonLabel="clearButtonLabel"
                            id="store-search-input"
                            isAlwaysExpanded
                            name="store-search-input"
                            onChange={(e: string) => handleStoresChangeSearchValue(e)}
                            placeholder="Search"
                            size={INPUT_SIZES.STANDARD}
                            value={gridStoresSearchValue}
                        />
                        <RadialButton text="Delete All" style={{ color: "#006CFA", marginLeft: '30%', fontSize: '12px', marginTop: '20px' }} onClick={onStoresDeleteData} variant={BUTTON_VARIANTS.TEXT} >
                        </RadialButton>
                    </div>
                    <StyledComponents.StyledTableContainerStores>
                        <StyledComponents.StyledTableWrapper className="ag-theme-alpine">
                            <AgGridReact
                                rowData={gridStoresData}
                                columnDefs={columnDefStores}
                                rowSelection="multiple"
                                suppressRowClickSelection={false}
                                pagination={true}
                                paginationPageSize={15}
                                onCellClicked={onCellClickedStores}
                                onGridReady={onGridStoresReady}
                            />
                        </StyledComponents.StyledTableWrapper>
                    </StyledComponents.StyledTableContainerStores>
                    <div style={{ fontSize: '12px', marginLeft: '10px' }}>{selectedStores?.length} Selected out of {gridStoresData?.length} Stores</div>

                </div>
            </StyledComponents.StyledTabPanel>
        ),
        renderTab: (props: any) => (
            <StyledComponents.StyledTab
                label="Stores"
                {...props}
            />
        ),
    });

    const [enterpriseGridApi, setEnterpriseGridApi] = useState<GridApi>();
    const onGridEnterprisesReady = (params: { api: GridApi; columnApi: ColumnApi }) => {
        setEnterpriseGridApi(params.api);
    };
    useEffect(() => {
        if (enterpriseGridApi) {
            enterpriseGridApi.setQuickFilter(gridEnterpriseSerachValue);
        }
    }, [gridEnterpriseSerachValue, enterpriseGridApi]);

    const [cnumberGridApi, setCnumberGridApi] = useState<GridApi>();
    const onGridCNumbersReady = (params: { api: GridApi; columnApi: ColumnApi }) => {
        setCnumberGridApi(params.api);
    };
    useEffect(() => {
        if (cnumberGridApi) {
            cnumberGridApi.setQuickFilter(gridCNumberSerachValue);
        }
    }, [gridCNumberSerachValue, cnumberGridApi]);


    const [storesGridApi, setStoresGridApi] = useState<GridApi>();
    const onGridStoresReady = (params: { api: GridApi; columnApi: ColumnApi }) => {
        setStoresGridApi(params.api);
    };
    useEffect(() => {
        if (storesGridApi) {
            storesGridApi.setQuickFilter(gridStoresSearchValue);
        }
    }, [gridStoresSearchValue, storesGridApi]);

    return (
        <div style={{ height: '80vh', paddingRight:'5px', paddingTop:'12px' }}>
            <StyledComponents.StyledTabs
                activeItemIndex={activeItemIndex}
                alignment="left"
                items={tabs}
                onActiveItemChange={setActiveItemIndex}
                tabsLabel=""
            />
            <RadialButton text="Close" style={{ color: "#006CFA", marginLeft: '80%', width:'80px' }} onClick={onClose} variant={BUTTON_VARIANTS.TEXT} >
            </RadialButton></div>
    );
};